import React, { useState } from 'react';
import LocationPicker from './LocationPicker';
import './SuggestionModal.css';

const SuggestionModal = ({ rink, onClose, onSubmit, apiKey }) => {
    const [suggestionType, setSuggestionType] = useState('');
    const [status, setStatus] = useState('');
    const [condition, setCondition] = useState('');
    const [reason, setReason] = useState('');
    const [newLocation, setNewLocation] = useState(rink.location || { lat: 45.5017, lng: -73.5673 });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!suggestionType) {
            alert('Veuillez sélectionner un type de modification');
            return;
        }

        if (suggestionType === 'status_condition' && !status && !condition) {
            alert('Veuillez sélectionner au moins un statut ou une condition');
            return;
        }

        if (suggestionType === 'location' && !newLocation) {
            alert('Veuillez sélectionner un emplacement sur la carte');
            return;
        }

        setIsSubmitting(true);
        try {
            const currentValue = {
                status: rink.ouvert == 1 ? 'Ouverte' : 'Fermée',
                condition: rink.condition,
                location: rink.location
            };

            const suggestedValue = suggestionType === 'location'
                ? { location: newLocation }
                : {
                    status: status || currentValue.status,
                    condition: condition || currentValue.condition
                };

            await onSubmit(suggestionType, currentValue, suggestedValue, reason);
            onClose();
        } catch (error) {
            console.error('Error submitting suggestion:', error);
            alert('Erreur lors de la soumission. Veuillez réessayer.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="suggestion-modal-overlay" onClick={onClose}>
            <div className="suggestion-modal" onClick={(e) => e.stopPropagation()}>
                <div className="suggestion-modal__header">
                    <h3>Suggérer une modification</h3>
                    <button className="suggestion-modal__close" onClick={onClose}>
                        ✕
                    </button>
                </div>

                <div className="suggestion-modal__body">
                    <p className="suggestion-modal__rink-name">{rink.nom}</p>

                    {/* Type selection - Location only */}
                    <div className="suggestion-modal__section">
                        <label className="suggestion-modal__label">Type de modification</label>
                        <div className="suggestion-modal__radio-group">
                            <label className="suggestion-modal__radio">
                                <input
                                    type="radio"
                                    name="type"
                                    value="location"
                                    checked={suggestionType === 'location'}
                                    onChange={(e) => setSuggestionType(e.target.value)}
                                />
                                <span>Emplacement</span>
                            </label>
                        </div>
                    </div>

                    {/* Status/Condition form */}
                    {suggestionType === 'status_condition' && (
                        <div className="suggestion-modal__section">
                            <label className="suggestion-modal__label">Statut</label>
                            <select
                                className="suggestion-modal__select"
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                            >
                                <option value="">Sélectionner...</option>
                                <option value="Ouverte">Ouverte</option>
                                <option value="Fermée">Fermée</option>
                            </select>

                            <label className="suggestion-modal__label">Condition</label>
                            <select
                                className="suggestion-modal__select"
                                value={condition}
                                onChange={(e) => setCondition(e.target.value)}
                            >
                                <option value="">Sélectionner...</option>
                                <option value="Excellente">Excellente</option>
                                <option value="Bonne">Bonne</option>
                                <option value="Mauvaise">Mauvaise</option>
                            </select>

                            <label className="suggestion-modal__label">Raison (optionnel)</label>
                            <textarea
                                className="suggestion-modal__textarea"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Ex: J'étais sur place et la patinoire était fermée"
                                rows="3"
                            />
                        </div>
                    )}

                    {/* Location form */}
                    {suggestionType === 'location' && (
                        <div className="suggestion-modal__section">
                            <LocationPicker
                                initialPosition={rink.location || { lat: 45.5017, lng: -73.5673 }}
                                onLocationChange={setNewLocation}
                                apiKey={apiKey}
                            />

                            <label className="suggestion-modal__label">Raison de la modification (optionnel)</label>
                            <textarea
                                className="suggestion-modal__textarea"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Ex: L'emplacement actuel est incorrect, la patinoire se trouve ici"
                                rows="3"
                            />
                        </div>
                    )}
                </div>

                <div className="suggestion-modal__footer">
                    <button className="suggestion-modal__button suggestion-modal__button--cancel" onClick={onClose}>
                        Annuler
                    </button>
                    <button
                        className="suggestion-modal__button suggestion-modal__button--submit"
                        onClick={handleSubmit}
                        disabled={isSubmitting || !suggestionType}
                    >
                        {isSubmitting ? 'Envoi...' : 'Soumettre'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuggestionModal;
